import { Button, CircularProgress } from "@mui/material"

export const SavingButton = ({ isSaving, label, ...props }: any) => (
  <Button {...props} variant="contained">
    {isSaving ? <CircularProgress size={20} color="inherit" /> : label}
  </Button>
)
